module.exports = __webpack_public_path__ + "/public/font/985cd024ea0b1184baa63675d2c6b267.woff";